import { render, staticRenderFns } from "./ar-SA.vue?vue&type=template&id=3d13374e&"
import script from "./ar-SA.vue?vue&type=script&lang=js&"
export * from "./ar-SA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d13374e')) {
      api.createRecord('3d13374e', component.options)
    } else {
      api.reload('3d13374e', component.options)
    }
    module.hot.accept("./ar-SA.vue?vue&type=template&id=3d13374e&", function () {
      api.rerender('3d13374e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/ar-SA.vue"
export default component.exports